import React from "react";
import { AppBar, Box, Container, LinearProgress, Toolbar } from "@mui/material";
import useEmailHeaderFooter from "../hooks/useEmailHeaderFooter";

const OnsiteReuseContainer = ({ children, maxWidth = "md" }) => {
  // Single API call for both header and footer
  const { data, isLoading } = useEmailHeaderFooter();

  return (
    <Box minHeight="100vh" display="flex" flexDirection="column">
      {/* --- HEADER --- */}
      {isLoading ? (
        <LinearProgress />
      ) : (
        <AppBar position="static" style={{ backgroundColor: "#054054" }}>
          <Toolbar style={{ justifyContent: "center" }}>
            <Container maxWidth="lg">
              {data?.headerUrl && (
                <img
                  alt="header"
                  src={data.headerUrl}
                  style={{
                    display: "block",
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              )}
            </Container>
          </Toolbar>
        </AppBar>
      )}

      {/* --- MAIN CONTENT --- */}
      <Container sx={{ flexGrow: 1, py: 2 }} maxWidth={maxWidth}>
        {children}
      </Container>

      {/* --- FOOTER --- */}
      {isLoading ? (
        <LinearProgress />
      ) : (
        <Container maxWidth="lg" sx={{ p: 0 }}>
          {data?.footerUrl && (
            <img
              alt="footer"
              src={data.footerUrl}
              style={{
                display: "block",
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
                width: "100%",
              }}
            />
          )}
        </Container>
      )}
    </Box>
  );
};

export default OnsiteReuseContainer;
